import subDays from 'date-fns/subDays'
import parseISO from 'date-fns/parseISO'
import { differenceInDays, format } from '@/helpers/date.js'

export const timeframeDefault = {
  start: subDays(new Date(), 5).toISOString(),
  end: new Date().toISOString()
}

export const timestampDefault = {
  start: subDays(new Date(), 5).toISOString(),
  end: new Date().toISOString()
}

export const lastWeekTimeframe = {
  start: subDays(new Date(), 6).toISOString(),
  end: new Date().toISOString()
}

export const chartToggleDefault = {
  value: 'overtime',
  options: [
    {
      value: 'overtime',
      label: 'Over Time'
    },
    {
      value: 'accumulative',
      label: 'Accumulative'
    }
  ]
}

export const intervalDefault = {
  value: 'day',
  options: [
    {
      label: 'Hour',
      value: 'hour'
    },
    {
      label: 'Day',
      value: 'day'
    },
    {
      label: 'Week',
      value: 'week'
    },
    {
      label: 'Month',
      value: 'month'
    },
    {
      label: 'No Intervals',
      value: 'all'
    }
  ]
}

export const getDateFormatByInterval = (date, interval) => {
  if (typeof date === 'string') date = parseISO(date)
  if (interval.value === 'hour') {
    return format(date, 'M/d/yyyy: ha')
  }
  if (interval.value === 'week') {
    return 'Week of ' + format(date, 'MMM d, yyyy')
  }
  if (interval.value === 'month') {
    return format(date, 'MMMM, yyyy')
  }
  return format(date, 'MMM d, yyyy')
}

export const getXLabelsFormatted = (labels, interval) => {
  return labels.map((d, i) => {
    if (typeof d === 'string') d = parseISO(d)
    if (interval.value === 'hour') {
      return format(d, 'ha')
    }
    if (interval.value === 'week') {
      return 'Week of ' + format(d, 'M/d')
    }
    if (interval.value === 'month') {
      return format(d, 'MMM')
    }
    return format(d, 'M/d')
  })
}

export const getSinceRelease = timestamp => {
  return timestamp && (timestamp.key === 'first7release' || timestamp.key === 'first30release') ? timestamp.relative : false
}

export const setIntervalOptions = (timestamp, hideHours, showIntervalAll = false) => {
  let options = []
  let selected = 'day'

  // The difference is always going to be one less than what we're trying to figure out here
  const days = differenceInDays(timestamp.end, timestamp.start) + 1

  if (days < 30 && timestamp.key !== 'allTime' && !hideHours) {
    options.push({ label: 'Hour', value: 'hour' })
  }
  if (days <= 365 || timestamp.key === 'allTime' || timestamp.key === 'first7release' || timestamp.key === 'first30release') {
    options.push({ label: 'Day', value: 'day' })
  }
  if ((days <= 365 && days >= 7) || timestamp.key === 'allTime') {
    options.push({ label: 'Week', value: 'week' })
  }
  if (days >= 28 || timestamp.key === 'allTime') { // using 28 for February
    options.push({ label: 'Month', value: 'month' })
  }

  if (showIntervalAll) {
    options.push({ label: 'No Intervals', value: 'all' })
  }

  if (days < 7 && timestamp.key !== 'allTime') { selected = 'hour' }
  if (days >= 30 && days < 180) { selected = 'week' }
  if (days >= 180 || timestamp.key === 'allTime') { selected = 'month' }

  return {
    value: selected,
    options: options
  }
}

export default {
  timeframeDefault,
  timestampDefault,
  lastWeekTimeframe,
  chartToggleDefault,
  intervalDefault,
  getDateFormatByInterval,
  getSinceRelease,
  getXLabelsFormatted,
  setIntervalOptions
}
